/**
 * General purpose constants
 */
export const General = {
  pageMaxWidth: 1260,
};
